// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__eecxh","content":"styles_content__NVLp-","table_header":"styles_table_header__M9kt9","left":"styles_left__I2g1i","all":"styles_all__CfbiP"};